import { Link } from "react-router-dom";
import { products, contactDetails } from "@/mocks/products";

const legalLinks = [
  { to: "/agb", label: "AGB" },
  { to: "/datenschutz", label: "Datenschutz" },
  { to: "/impressum", label: "Impressum" },
];

function SiteFooter() {
  const year = new Date().getFullYear();

  return (
    <footer className="w-full bg-primary-800 text-background-50">
      <div className="w-full px-4 md:px-8 py-12 md:py-16">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-10">
          <div className="lg:col-span-2 max-w-md">
            <div className="flex items-center gap-3">
              <span className="flex flex-col items-center justify-center w-11 h-11 rounded-md bg-background-50 text-primary-800">
                <span className="text-[9px] font-label leading-none uppercase">seit</span>
                <span className="text-sm font-heading font-semibold leading-none mt-0.5">1956</span>
              </span>
              <span className="font-heading font-bold text-2xl tracking-tight">DREXELIUS</span>
            </div>
            <p className="mt-5 text-sm leading-relaxed text-background-100/90">
              Spezialfabrik für Drückerverbindungen. Wir fertigen Türdrücker-Stifte,
              Wechsel-Schlossstifte, PSW-Stifte und Vierkant-Stifte in gleichbleibender Qualität –
              für Industrie, Handel und Handwerk.
            </p>
            <a
              href={contactDetails.phoneHref}
              className="mt-6 inline-flex items-center gap-2 h-11 px-5 rounded-md bg-background-50 text-primary-800 font-label text-sm uppercase tracking-wide whitespace-nowrap hover:bg-primary-100 transition-colors"
            >
              <i className="ri-phone-line text-base" aria-hidden="true" />
              Jetzt anrufen: {contactDetails.phone}
            </a>
          </div>

          <div>
            <h4 className="font-heading text-sm uppercase tracking-wider text-background-100">
              <a href="#footer-produkte" className="hover:text-background-50">
                Produkte
              </a>
            </h4>
            <ul id="footer-produkte" className="mt-4 flex flex-col gap-2.5">
              {products.map((product) => (
                <li key={product.slug}>
                  <Link
                    to={`/${product.slug}`}
                    className="text-sm text-background-100/85 hover:text-background-50 transition-colors"
                  >
                    {product.name}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div>
            <h4 className="font-heading text-sm uppercase tracking-wider text-background-100">
              <a href="#footer-kontakt" className="hover:text-background-50">
                Kontakt
              </a>
            </h4>
            <ul id="footer-kontakt" className="mt-4 flex flex-col gap-3 text-sm text-background-100/85">
              <li className="flex items-start gap-2">
                <i className="ri-map-pin-line mt-0.5 text-accent-300" aria-hidden="true" />
                <span>
                  {contactDetails.company}
                  <br />
                  {contactDetails.location}
                </span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-phone-line text-accent-300" aria-hidden="true" />
                <a href={contactDetails.phoneHref} className="hover:text-background-50">
                  Telefon {contactDetails.phone}
                </a>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-printer-line text-accent-300" aria-hidden="true" />
                <span>Telefax {contactDetails.fax}</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-mail-send-line text-accent-300" aria-hidden="true" />
                <Link to="/kontakt" className="hover:text-background-50">
                  Zum Kontaktformular
                </Link>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="w-full border-t border-background-50/20">
        <div className="w-full px-4 md:px-8 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-100/80">
          <p>
            © {year} {contactDetails.company}
          </p>
          <div className="flex items-center gap-4">
            {legalLinks.map((link) => (
              <Link key={link.to} to={link.to} className="hover:text-background-50 transition-colors">
                {link.label}
              </Link>
            ))}
            <a href="#top" className="flex items-center gap-1 hover:text-background-50 transition-colors">
              nach oben
              <i className="ri-arrow-up-line" aria-hidden="true" />
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}

export default SiteFooter;